/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Formcontent_General_Mailsubjecttouser4Inputs */

const ja_contact_formcontent_general_mailsubjecttouser4 = /** @type {(inputs: Contact_Formcontent_General_Mailsubjecttouser4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ頂きありがとうございます。`)
};

const en_contact_formcontent_general_mailsubjecttouser4 = /** @type {(inputs: Contact_Formcontent_General_Mailsubjecttouser4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for contacting us!`)
};

/**
* | output |
* | --- |
* | "Thank you for contacting us!" |
*
* @param {Contact_Formcontent_General_Mailsubjecttouser4Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const contact_formcontent_general_mailsubjecttouser4 = /** @type {((inputs?: Contact_Formcontent_General_Mailsubjecttouser4Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Formcontent_General_Mailsubjecttouser4Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_formcontent_general_mailsubjecttouser4(inputs)
	return en_contact_formcontent_general_mailsubjecttouser4(inputs)
});
export { contact_formcontent_general_mailsubjecttouser4 as "contact_formContent_general_mailSubjectToUser" }